/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/reInviteUser.config.json";
import notification from "../config/notifications.config.json";
import { VApplication } from "../../../application";
import { AppNavigatorService } from "../../appNavigatorService";

import axios from "axios";

export interface reInviteUserProps {
  email: string;
  apiURL: string;
}

export interface IReInviteUserMethods extends IPluginMethodMap {
  getReInviteUser(args: reInviteUserProps): Promise<any>;
}

const LoginPageServ = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export class ReInviteUserService implements IAgentPlugin {
  readonly methods: IReInviteUserMethods;

  constructor() {
    this.methods = {
      getReInviteUser: this.getReInviteUser.bind(this),
    };
  }

  async getReInviteUser(args: reInviteUserProps) {
    const srv = LoginPageServ();
    try {
      const res = await axios.post(
        `${args?.apiURL}${config?.reInviteEP}`,
        {
          email: args?.email,
          type: config?.inviteType,
        },
        {
          headers: {
            authentication: srv?.getToken(),
          },
        }
      );
      if (res?.data) {
        return {
          data: res?.data?.message,
          notification: notification?.reInviteUser,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }
}
